
import Glider from './glider.js'
var bestPricesGlinder;
var bestPrices = function () {
    
    var getbestPrices = function() {

        bestPricesGlinder = new Glider(document.querySelector('.gliderBestPrice'), {
            // Mobile-first defaults
            slidesToShow: 2,
            slidesToScroll: 2,
            scrollLock: true,
            scrollLockDelay:100,
            duration:1,
            draggable: true,
            eventPropagate:false,
            dots: '.dots',
            arrows: {
                prev: '.glider-prev',
                next: '.glider-next'
            },
            responsive: [
                {
                    breakpoint: 270,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        itemWidth: 270,
                        duration: 0.25
                    }
                },
                {
                    breakpoint: 775,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        itemWidth: 270,
                        duration: 0.25
                    }
                },
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        itemWidth: 270,
                        duration: 0.25
                    }
                },{
                    // screens greater than >= 1024px
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        itemWidth: 270,
                        duration: 0.25
                    }
                }
            ]
        });

        
        

    }
    return {
        init: function() {
            getbestPrices();
        }
    };
}();
    
$(function () {
    bestPrices.init();
});
